// extracted by mini-css-extract-plugin
export default {"tabContent":"TabContent_tabContent__3yW8g","main":"TabContent_main__FTqHo","header":"TabContent_header__7HWb9","content":"TabContent_content__TsADP"};